import { service } from '@ember/service';
import Component from '@glimmer/component';
import nameSort from 'scaleflow/utils/nameSort';

/**
 * People table component with optional grouping
 *
 * @param {Array} people - Array of person models to display
 * @param {String} grouping - Optional grouping key: 'team', 'role', or null
 *
 * Displays a 3-column table with Name, Teams, and Roles.
 * When grouping is provided, groups people by the specified attribute.
 * People with multiple teams/roles appear in multiple groups.
 */
export default class PeopleTableIndexComponent extends Component {
  @service intl;

  get flatRows() {
    return this.args.people;
  }

  get groupedRows() {
    if (!this.args.grouping) return null;
    return this.getGroupedPeopleByKey(this.args.people, this.args.grouping);
  }

  getGroupedPeopleByKey(list, groupKey) {
    switch (groupKey) {
      case 'role': {
        return this.sortByRole(list);
      }
      case 'team': {
        return this.sortByTeam(list);
      }
      default: {
        return this.sortByRole(list);
      }
    }
  }

  sortByTeam(list) {
    const groupedList = {};
    const NONE = {
      name: 'No Team',
      content: [],
    };
    list.forEach((item) => {
      if (!item.teams.length) return NONE.content.push(item);
      item.teams.forEach((team) => {
        const ref = groupedList[team.name];
        if (ref && ref.content) return ref.content.push(item);
        else {
          groupedList[team.name] = {
            name: team.name,
            id: team.id,
            content: [item],
          };
        }
      });
    });
    const sortedGroupList = {};
    const sorted = Object.keys(groupedList).sort((a, b) =>
      nameSort(groupedList[a]['name'], groupedList[b]['name']),
    );
    sorted.forEach((key) => {
      sortedGroupList[key] = groupedList[key];
    });

    if (NONE.content.length !== 0) {
      sortedGroupList.NONE = NONE;
    }
    return sortedGroupList;
  }

  sortByRole(list) {
    const groupedList = {};
    const NONE = {
      name: 'No Role',
      content: [],
    };
    list.forEach((item) => {
      if (!item.roles.length) return NONE.content.push(item);
      item.roles.forEach((role) => {
        const ref = groupedList[role.name];
        if (ref && ref.content) return ref.content.push(item);
        else {
          groupedList[role.name] = {
            name: role.name,
            id: role.id,
            content: [item],
          };
        }
      });
    });
    const sortedGroupList = {};
    const sorted = Object.keys(groupedList).sort((a, b) =>
      nameSort(groupedList[a]['name'], groupedList[b]['name']),
    );
    sorted.forEach((key) => {
      sortedGroupList[key] = groupedList[key];
    });

    if (NONE.content.length !== 0) {
      sortedGroupList.NONE = NONE;
    }
    return sortedGroupList;
  }
}
